import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import HomePage from "./pages/HomePage";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                setTimeout(
                    () => el.scrollIntoView({ behavior: "smooth" }),
                    50
                );
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
};

function App() {
    return (
        <div className="App grain-overlay">
            <BrowserRouter>
                <ScrollManager />
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/impressum" element={<Impressum />} />
                        <Route path="/datenschutz" element={<Datenschutz />} />
                    </Routes>
                </main>
                <Footer />
                <CookieBanner />
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "#1f2d3d",
                            color: "#f5f1e8",
                            border: "1px solid rgba(245,241,232,0.2)",
                            fontFamily: "Outfit, sans-serif",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
